import { createApp, reactive, nextTick, h } from 'vue';
import VueSelect from 'vue3-select-component';

export default function initNetworkIntakeForm() {
	const form = document.querySelector('.network-intake-form-gf, .libarary-intake-form-gf');
	console.log(form);
	if (!form) return;

	const appContainer = document.createElement('div');
	appContainer.id = 'network-intake-app';
	form.parentNode.insertBefore(appContainer, form);
	appContainer.appendChild(form);

	const app = createApp({
		data() {
			return {
				selectFields: [],
				fieldValues: reactive({}),
				validationErrors: reactive({})
			};
		},
		methods: {
			initializeSelects() {
				const selects = this.$el.querySelectorAll('select.vue-select-wrapper');
				selects.forEach(select => {
					if (select.dataset.vueInitialized) return;
					
					const fieldId = select.id || select.name;
					const isMultiple = select.multiple;
					const options = Array.from(select.options)
						.filter(opt => opt.value !== '')
						.map(opt => ({
							label: opt.text,
							value: opt.value
						}));

					const placeholder = select.options[0]?.value === '' ? select.options[0].text : 'Select...';

					if (isMultiple) {
						const selectedValues = Array.from(select.selectedOptions).map(opt => opt.value);
						this.fieldValues[fieldId] = selectedValues;
					} else {
						this.fieldValues[fieldId] = select.value || '';
					}

					const vueSelectContainer = document.createElement('div');
					vueSelectContainer.className = 'vue-select-container';
					select.parentNode.insertBefore(vueSelectContainer, select);

					this.selectFields.push({
						id: fieldId,
						element: select,
						container: vueSelectContainer,
						isMultiple,
						options,
						placeholder,
						name: select.name
					});

					select.dataset.vueInitialized = 'true';
					select.style.display = 'none';

					this.renderVueSelect(this.selectFields[this.selectFields.length - 1]);
				});
			},
			renderVueSelect(field) {
				const self = this;
				const selectApp = createApp({
					data() {
						return {
							value: self.fieldValues[field.id]
						};
					},
					watch: {
						value(newVal) {
							self.updateFieldValue(field.id, newVal, field);
						}
					},
					render() {
						return h(VueSelect, {
							modelValue: this.value,
							'onUpdate:modelValue': (val) => { this.value = val; },
							options: field.options,
							isMulti: field.isMultiple,
							placeholder: field.placeholder,
							class: 'gf-vue-select'
						});
					}
				});
				selectApp.mount(field.container);
				field.vueApp = selectApp;
			},
			updateFieldValue(fieldId, value, selectField) {
				this.fieldValues[fieldId] = value;
				
				const select = selectField.element;
				if (selectField.isMultiple) {
					Array.from(select.options).forEach(opt => {
						opt.selected = Array.isArray(value) && value.includes(opt.value);
					});
				} else {
					select.value = value || '';
				}
				
				select.dispatchEvent(new Event('change', { bubbles: true }));
			},
			async validateOrganization(name) {
				// Placeholder for AJAX validation to check if org already exists
				// Returns { exists: boolean, message: string }
				return { exists: false, message: '' };
			},
			destroySelects() {
				this.selectFields.forEach(field => {
					if (field.vueApp) {
						field.vueApp.unmount();
					}
					if (field.container && field.container.parentNode) {
						field.container.parentNode.removeChild(field.container);
					}
					if (field.element) {
						field.element.style.display = '';
						delete field.element.dataset.vueInitialized;
					}
				});
				this.selectFields = [];
			}
		},
		mounted() {
			this.initializeSelects();
		},
		beforeUnmount() {
			this.destroySelects();
		}
	});
	// Register vue3-select-component
	app.component('VueSelect', VueSelect);

	app.mount('#network-intake-app');

	// Re-initialize on Gravity Forms page change (multi-page forms)
	jQuery(document).on('gform_page_loaded', function() {
		nextTick(() => {
			const appInstance = app._instance;
			if (appInstance) {
				appInstance.proxy.initializeSelects();
			}
		});
	});

	return app;
}
